import {
  PiArrowsHorizontalThin,
  PiFishThin,
  PiLineSegmentThin,
  PiPolygonThin,
  PiQuestion,
  PiFootprintsThin,
} from 'react-icons/pi';
import { IconType } from 'react-icons';
// import { FaCircleCheck, FaCircleXmark } from 'react-icons/fa6';
export const detectorTypeToIcon = (
  detectorType: string | undefined
): React.ElementType => {
  let IconComponent: IconType | React.FC<React.SVGProps<SVGSVGElement>>;

  switch (detectorType) {
    case 'area':
      IconComponent = PiPolygonThin;
      break;
    case 'line':
      IconComponent = PiLineSegmentThin;
      break;
    case 'cable':
      IconComponent = PiArrowsHorizontalThin;
      break;
    case 'fishing':
      IconComponent = PiFishThin;
      break;
    case 'grounding':
      IconComponent = PiFootprintsThin;
      break;
    default:
      IconComponent = PiQuestion;
  }

  return IconComponent;
};
